// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* One bill / quote in the list: round icon, number and date, period, optional value,
 * edit and delete always visible on the right. Loaded with @use by each row component. */
:host {
  display: block;
}

.record-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 12px 12px 16px;
  transition: background-color 0.15s ease;
}
.record-row:hover {
  background: rgba(var(--ion-color-primary-rgb), 0.06);
}
.record-row__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
}
.record-row__icon ion-icon {
  font-size: 21px;
}
.record-row {
  /* Number, date and period open the detail */
}
.record-row__main {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
}
.record-row__main:focus-visible {
  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);
  outline-offset: 2px;
  border-radius: 6px;
}
.record-row__title {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 4px 10px;
  font-size: 15px;
  font-weight: 600;
}
.record-row__date {
  font-size: 13px;
  font-weight: 500;
  color: var(--ion-color-medium-shade);
}
.record-row__period {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  color: var(--ion-color-medium-shade);
}
.record-row__period ion-icon {
  flex-shrink: 0;
  font-size: 15px;
}
.record-row__value {
  flex-shrink: 0;
  font-size: 15px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.record-row__actions {
  display: flex;
  flex-shrink: 0;
  gap: 2px;
}
.record-row__action {
  display: grid;
  place-items: center;
  width: 38px;
  height: 38px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  color: var(--ion-color-medium);
  line-height: 0;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
}
.record-row__action ion-icon {
  font-size: 19px;
}
.record-row__action:hover, .record-row__action:focus-visible {
  outline: none;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.1);
}
.record-row__action--danger:hover, .record-row__action--danger:focus-visible {
  color: var(--ion-color-danger);
  background: rgba(var(--ion-color-danger-rgb), 0.1);
}
.record-row {
  /* Phones: the value goes under the text */
}
@media (max-width: 575px) {
  .record-row {
    flex-wrap: wrap;
    gap: 6px 12px;
    padding: 12px;
  }
  .record-row__main {
    flex-basis: calc(100% - 42px - 12px - 80px - 12px);
  }
  .record-row__value {
    order: 5;
    margin-left: 54px;
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/_record-row.scss","webpack://./src/components/general%20components/bill/bill-component.scss"],"names":[],"mappings":"AAAA;yFAAA;AAGA;EACE,cAAA;ACAF;;ADGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;EACA,uCAAA;ACAF;ADEE;EACE,oDAAA;ACAJ;ADGE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,oDAAA;ACDJ;ADGI;EACE,eAAA;ACDN;ADtBA;EA2BE,4CAAA;ACFF;ADGE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;ACDJ;ADGI;EACE,0DAAA;EACA,mBAAA;EACA,kBAAA;ACDN;ADKE;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;ACHJ;ADME;EACE,eAAA;EACA,gBAAA;EACA,oCAAA;ACJJ;ADOE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,oCAAA;ACLJ;ADOI;EACE,cAAA;EACA,eAAA;ACLN;ADSE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,mBAAA;ACPJ;ADUE;EACE,aAAA;EACA,cAAA;EACA,QAAA;ACRJ;ADWE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;ACTJ;ADWI;EACE,eAAA;ACTN;ADYI;EAEE,aAAA;EACA,+BAAA;EACA,mDAAA;ACXN;ADcI;EAEE,8BAAA;EACA,kDAAA;ACbN;AD1GA;EA2HE,0CAAA;ACdF;ADeE;EA5HF;IA6HI,eAAA;IACA,aAAA;IACA,aAAA;ECZF;EDcE;IACE,kDAAA;ECZJ;EDeE;IACE,QAAA;IACA,iBAAA;IACA,eAAA;ECbJ;AACF","sourcesContent":["/* One bill / quote in the list: round icon, number and date, period, optional value,\n * edit and delete always visible on the right. Loaded with @use by each row component. */\n\n:host {\n  display: block;\n}\n\n.record-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 12px 12px 16px;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background: rgba(var(--ion-color-primary-rgb), 0.06);\n  }\n\n  &__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.12);\n\n    ion-icon {\n      font-size: 21px;\n    }\n  }\n\n  /* Number, date and period open the detail */\n  &__main {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    flex: 1;\n    min-width: 0;\n    padding: 0;\n    border: 0;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    text-align: left;\n    cursor: pointer;\n\n    &:focus-visible {\n      outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n      outline-offset: 2px;\n      border-radius: 6px;\n    }\n  }\n\n  &__title {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: baseline;\n    gap: 4px 10px;\n    font-size: 15px;\n    font-weight: 600;\n  }\n\n  &__date {\n    font-size: 13px;\n    font-weight: 500;\n    color: var(--ion-color-medium-shade);\n  }\n\n  &__period {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 13px;\n    color: var(--ion-color-medium-shade);\n\n    ion-icon {\n      flex-shrink: 0;\n      font-size: 15px;\n    }\n  }\n\n  &__value {\n    flex-shrink: 0;\n    font-size: 15px;\n    font-weight: 700;\n    font-variant-numeric: tabular-nums;\n    white-space: nowrap;\n  }\n\n  &__actions {\n    display: flex;\n    flex-shrink: 0;\n    gap: 2px;\n  }\n\n  &__action {\n    display: grid;\n    place-items: center;\n    width: 38px;\n    height: 38px;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: transparent;\n    color: var(--ion-color-medium);\n    line-height: 0;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease;\n\n    ion-icon {\n      font-size: 19px;\n    }\n\n    &:hover,\n    &:focus-visible {\n      outline: none;\n      color: var(--ion-color-primary);\n      background: rgba(var(--ion-color-primary-rgb), 0.1);\n    }\n\n    &--danger:hover,\n    &--danger:focus-visible {\n      color: var(--ion-color-danger);\n      background: rgba(var(--ion-color-danger-rgb), 0.1);\n    }\n  }\n\n  /* Phones: the value goes under the text */\n  @media (max-width: 575px) {\n    flex-wrap: wrap;\n    gap: 6px 12px;\n    padding: 12px;\n\n    &__main {\n      flex-basis: calc(100% - 42px - 12px - 80px - 12px);\n    }\n\n    &__value {\n      order: 5;\n      margin-left: 54px;\n      font-size: 14px;\n    }\n  }\n}\n","/* One bill / quote in the list: round icon, number and date, period, optional value,\n * edit and delete always visible on the right. Loaded with @use by each row component. */\n:host {\n  display: block;\n}\n\n.record-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 12px 12px 16px;\n  transition: background-color 0.15s ease;\n}\n.record-row:hover {\n  background: rgba(var(--ion-color-primary-rgb), 0.06);\n}\n.record-row__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.12);\n}\n.record-row__icon ion-icon {\n  font-size: 21px;\n}\n.record-row {\n  /* Number, date and period open the detail */\n}\n.record-row__main {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n}\n.record-row__main:focus-visible {\n  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n  outline-offset: 2px;\n  border-radius: 6px;\n}\n.record-row__title {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: baseline;\n  gap: 4px 10px;\n  font-size: 15px;\n  font-weight: 600;\n}\n.record-row__date {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--ion-color-medium-shade);\n}\n.record-row__period {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  color: var(--ion-color-medium-shade);\n}\n.record-row__period ion-icon {\n  flex-shrink: 0;\n  font-size: 15px;\n}\n.record-row__value {\n  flex-shrink: 0;\n  font-size: 15px;\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.record-row__actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: 2px;\n}\n.record-row__action {\n  display: grid;\n  place-items: center;\n  width: 38px;\n  height: 38px;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  background: transparent;\n  color: var(--ion-color-medium);\n  line-height: 0;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n}\n.record-row__action ion-icon {\n  font-size: 19px;\n}\n.record-row__action:hover, .record-row__action:focus-visible {\n  outline: none;\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.1);\n}\n.record-row__action--danger:hover, .record-row__action--danger:focus-visible {\n  color: var(--ion-color-danger);\n  background: rgba(var(--ion-color-danger-rgb), 0.1);\n}\n.record-row {\n  /* Phones: the value goes under the text */\n}\n@media (max-width: 575px) {\n  .record-row {\n    flex-wrap: wrap;\n    gap: 6px 12px;\n    padding: 12px;\n  }\n  .record-row__main {\n    flex-basis: calc(100% - 42px - 12px - 80px - 12px);\n  }\n  .record-row__value {\n    order: 5;\n    margin-left: 54px;\n    font-size: 14px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
